import state from './resourcelog.state'
import mutations from './resourcelog.mutations'
import actions from './resourcelog.actions'

export default {
  state,
  mutations,
  actions
}
